import formatUndoSnapshot from './formatUndoSnapshot';
import { getObjectKeys, PendableFormatCommandMap } from 'roosterjs-editor-dom';
import { PluginEventType, SelectionRangeTypes } from 'roosterjs-editor-types';
import type { PendableFormatNames } from 'roosterjs-editor-dom';
import type { DocumentCommand, IEditor } from 'roosterjs-editor-types';
import type { CompatibleDocumentCommand } from 'roosterjs-editor-types/lib/compatibleTypes';

/**
 * @internal
 * Execute a document command
 * @param editor The editor instance
 * @param command The command to execute
 * @param addUndoSnapshotWhenCollapsed Optional, set to true to always add undo snapshot even current selection is collapsed.
 * Default value is false.
 * @param doWorkaroundForList Optional, set to true to do workaround for list in order to keep current format.
 * Default value is false.
 */
export default function execCommand(
    editor: IEditor,
    command: DocumentCommand | CompatibleDocumentCommand,
    apiName?: string
) {
    editor.focus();

    const formatter = () => editor.getDocument().execCommand(command, false, undefined);

    const selection = editor.getSelectionRangeEx();
    if (selection && selection.areAllCollapsed) {
        editor.addUndoSnapshot();
        const formatState = editor.getPendableFormatState(false /* forceGetStateFromDom */);
        formatter();
        const formatName = getObjectKeys(PendableFormatCommandMap).filter(
            x => PendableFormatCommandMap[x] == command
        )[0] as PendableFormatNames;

        if (formatName) {
            formatState[formatName] = !formatState[formatName];
            editor.triggerPluginEvent(PluginEventType.PendingFormatStateChanged, {
                formatState: formatState,
            });
        }
    } else {
        formatUndoSnapshot(
            editor,
            () => {
                const needToSwitchSelection = selection.type != SelectionRangeTypes.Normal;

                selection.ranges.forEach(range => {
                    if (needToSwitchSelection) {
                        editor.select(range);
                    }
                    formatter();
                });

                if (needToSwitchSelection) {
                    editor.select(selection);
                }
            },
            apiName
        );
    }
}
